export default __webpack_public_path__ + "static/media/028-message-in-a-bottle.cb946f09.png";